import { Pipe, PipeTransform } from '@angular/core';
import numeral from 'numeral';

@Pipe({
  name: 'numeral',
  standalone: true,
})
export class NumeralPipe implements PipeTransform {
  transform(value: unknown, format: string, nullStr = '-'): string {
    if (value === null || value === '') {
      return nullStr;
    }

    const formattedValue = numeral(value).format(format);
    return formattedValue;
  }
}
